import {JSX, lazy} from "react";
import {withInstrumentUtil} from "../utils/withInstrument.util";
import {ServiceLoadingComponentB} from "../components/loading/serviceLoading.component";

export interface ServiceStoreInterface {
    key: string;
    title: string;
    component: () => JSX.Element;
}
export const serviceStore: Record<string, ServiceStoreInterface> = {
    "FundWallet": {
        key: "fund-wallet",
        title: "Fund Account",
        component: withInstrumentUtil("fund-wallet", lazy(() => import("../pages/fundWallet").then((module) => ({
            default: module.FundWalletPage
        }))), <ServiceLoadingComponentB />)
    },
    "Transfer": {
        key: "transfer",
        title: "Transfer",
        component: withInstrumentUtil("transfer", lazy(() => import("../pages/transfer").then((module) => ({
            default: module.TransferPage
        }))), <ServiceLoadingComponentB />)
    },
    "Airtime": {
        key: "airtime",
        title: "Airtime",
        component: withInstrumentUtil("transfer", lazy(() => import("../pages/airtime").then((module) => ({
            default: module.AirtimePage
        }))))
    },
    "Data": {
        key: "data-top-up",
        title: "Data Top Up",
        component: withInstrumentUtil("data-top-up", lazy(() => import("../pages/data").then((module) => ({
            default: module.DataPage
        }))))
    },
    "Cable Tv": {
        key: "cable-tv",
        title: "TV",
        component: withInstrumentUtil("cable-tv", lazy(() => import("../pages/cableTv").then((module) => ({
            default: module.CableTvPage
        }))))
    },
    "Betting": {
        key: "betting",
        title: "Betting",
        component: withInstrumentUtil("betting", lazy(() => import("../pages/betting").then((module) => ({
            default: module.BettingPage
        }))))
    },
    "Flight": {
        key: "flight",
        title: "Flight",
        component: withInstrumentUtil("flight", lazy(() => import("../pages/flight").then((module) => ({
            default: module.FlightPage
        }))))
    },
    "KycVerification": {
        key: "kyc-verification",
        title: "Kyc Verification",
        component: withInstrumentUtil("kycVerification", lazy(() => import("../pages/kycVerification").then((module) => ({
            default: module.KycVerificationPage
        }))), <ServiceLoadingComponentB />)
    },
    "AllBeneficiaries": {
        key: "all-beneficiaries",
        title: "All Beneficiaries",
        component: withInstrumentUtil("all-beneficiaries",
            lazy(() => import("../pages/allBeneficiaries").then((module) => ({
                default: module.AllBeneficiariesPage
            }))),
            <ServiceLoadingComponentB />
        )
    },
}